import { z } from "zod";

export const getHardCodedTemplateFormSchema = z.object({
  template: z.string().trim().min(1, "formData.forms.errors.required"),
});

export type GetHardCodedTemplateFormType = z.infer<
  typeof getHardCodedTemplateFormSchema
>;

export interface HardCodedTemplateSelectorProps {
  isOpen: boolean;
  onClose: () => void;
  onChange: (content: string) => void;
}
